const formatId = (prefix: string, value: string): string =>
  `${prefix.trim()}:${value.trim()}`.replace(/\s+/g, '_');

export default formatId;
